import { SET_RESPONSE_STATUS } from 'constants/reduxActions';
export function setResponseStatus(statusCode) {
  return { type: SET_RESPONSE_STATUS, statusCode };
}
